/* guard: snippet ubacuje ovaj skript u svaku karticu (50x/strani) - izvrsi se samo jednom */
if(!window.__dossierAtcInit){window.__dossierAtcInit=1;
/* Dossier mobile ATC: add.js + cart drawer refresh (test) - v2 bez redirecta */
document.addEventListener('click', function(ev){
  var btn = ev.target.closest('.dossier-atc'); if(!btn) return;
  if(!btn.dataset.vid){ return; } /* link varijanta (Odaberi 3) - normalna navigacija */
  ev.preventDefault();
  var vid = btn.dataset.vid, orig = btn.textContent;
  btn.disabled = true; btn.textContent = btn.dataset.txtAdding || 'Adding...';
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: parseInt(vid), quantity: 1})})
  .then(function(r){ if(!r.ok) throw 0; return r.json(); })
  .then(function(){
    btn.textContent = btn.dataset.txtAdded || 'Added ✓'; btn.classList.add('added');
    setTimeout(function(){ btn.textContent = orig; btn.classList.remove('added'); btn.disabled = false; }, 2200);
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(s){
        var dr = document.querySelector('cart-drawer');
        if(s['cart-drawer'] && dr){
          var t = document.createElement('div'); t.innerHTML = s['cart-drawer'];
          var nd = t.querySelector('cart-drawer');
          if(nd){ dr.innerHTML = nd.innerHTML; }
          dr.classList.remove('is-empty');
        }
        var b = document.getElementById('cart-icon-bubble');
        if(s['cart-icon-bubble'] && b){
          var t2 = document.createElement('div'); t2.innerHTML = s['cart-icon-bubble'];
          var nb = t2.querySelector('#cart-icon-bubble');
          b.innerHTML = nb ? nb.innerHTML : s['cart-icon-bubble'];
        }
        dr = document.querySelector('cart-drawer');
        if(dr){
          if(typeof dr.open === 'function'){ dr.open(); }
          else { dr.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
        }
      })
      .catch(function(){ /* dodato je; drawer samo nije osvezen - NE navigiraj */ });
  })
  .catch(function(){ btn.disabled = false; btn.textContent = btn.dataset.txtError || 'Error - try again'; setTimeout(function(){ btn.textContent = orig; }, 2500); });
});

}
